<div class="modal">
  <div class="modal__content">
    <div class="window" [ngClass]="{'widget-padding': !isFirstStep}">

      @switch (data.PaymentMethod) {
        @case (thirdPartyCrypto.buyCryptoTypes.mercuryo) {
          <ng-container *ngTemplateOutlet="mercuryo"></ng-container>
        }
      }

      <ng-template #mercuryo>
        <div class="widget">
          <ng-container *ngTemplateOutlet="firstStep"></ng-container>
          @if (!isFirstStep) {
            <div id="mercuryo-widget"></div>
          }
        </div>
      </ng-template>

      <ng-template #firstStep>
        <i class="window__close icon-close" (click)="modal.close()"></i>
        <div class="widget__logo" [ngStyle]="{'paddingBottom': !isFirstStep ? '20px' : ''}">
          <img [src]="data?.Logo" alt="">
        </div>
        @if (isFirstStep) {
          <div class="widget__title">{{data?.ModalTitle}}</div>
          <div class="widget__content">
            @for (item of data.ModalContent.Steps | keyvalue; track item) {
              <div class="widget__content--item">
                <div class="widget__content--item-step">{{item?.key}}</div>
                {{item?.value}}
              </div>
            }
          </div>
          <div class="widget__payment-logo">
            @if (data?.PaymentLogo) {
              <img [src]="data?.PaymentLogo" alt="">
            }
          </div>
          <div class="widget__action">
            <button (click)="secondStep(data)" class="btn small">
              {{'btn.continue' | translate}}
            </button>
          </div>
        }
      </ng-template>
    </div>
  </div>
</div>
